"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var classnames_1 = require("classnames");
var Login_1 = require("./components/Login");
var getState_1 = require("../../../utils/getState");
var redirectOnRole_1 = require("../../../utils/redirectOnRole");
var LandingPage = function () {
    React.useEffect(function () {
        (0, redirectOnRole_1.default)();
    }, []);
    return (React.createElement("div", { className: "landing-page-contents flex-row-wrap" },
        React.createElement("div", { className: (0, classnames_1.default)({
                'landing-page-contents-left': true,
                'landing-page-contents-authorized': !(0, lodash_1.isEmpty)((0, getState_1.default)().user),
                'landing-page-contents-unauthorized': (0, lodash_1.isEmpty)((0, getState_1.default)().user),
            }) },
            React.createElement("div", { className: "landing-page-left-text" },
                React.createElement("h1", null, "Your powerful online Debt Recovery Platform"),
                React.createElement("p", null, "Helping you save time and money, rradarrecover is a powerful and effective online debt recovery solution brought to you by rradar \u2013 a legal enterprise dedicated to helping business navigate and overcome business risk."),
                React.createElement("p", null, "The secure 24/7 automated platform takes the time and stress away from chasing bad debtors, making it faster, easier and more accessible to keep track of the money owed to you, backed with the support our debt recovery team at your fingertips, ready to verify your documents and escalate on your behalf."),
                React.createElement("p", null, "Don\u2019t have a subscription or want to learn more? Get in touch:"),
                React.createElement("div", null,
                    React.createElement("p", { className: "information-block" },
                        React.createElement("i", { className: "fas fa-phone" }),
                        " 0300 014 996"),
                    React.createElement("p", { className: "information-block" },
                        React.createElement("i", { className: "fas fa-envelope" }),
                        " ",
                        React.createElement("a", { href: "mailto:recover@rradar.com" }, "recover@rradar.com")),
                    React.createElement("p", { className: "information-block" },
                        React.createElement("i", { className: "fas fa-globe" }),
                        " ",
                        React.createElement("a", { href: "https://www.rradar.com" }, "www.rradar.com"))))),
        (0, lodash_1.isEmpty)((0, getState_1.default)().user) ? (React.createElement("div", { className: "landing-page-contents-right" },
            React.createElement(Login_1.default, null))) : null));
};
exports.default = LandingPage;
